import ArticleIcon from "@mui/icons-material/Article";
import { AnalysisGroupCreate } from "./components/AnalysisGroupCreate";
import { AnalysisGroupList } from "./components/AnalysisGroupList";
import { AnalysisGroupEdit } from "./components/AnalysisGroupEdit";

const resource = {
  create: AnalysisGroupCreate,
  list: AnalysisGroupList,
  edit: AnalysisGroupEdit,
  icon: ArticleIcon,
};

export function formatGroupToSend(analysisGroup: any) {
  // If all clinicalTrialConfiguration field is empty remove to pass backend validation
  if (
    analysisGroup?.clinicalTrialConfiguration &&
    Object.values(analysisGroup.clinicalTrialConfiguration).every((v) => !v)
  ) {
    analysisGroup.clinicalTrialConfiguration = undefined;
  }
  // If not preset is selected, parse the
  if (
    analysisGroup.preset == null &&
    typeof analysisGroup.workflowConfiguration == "string" &&
    analysisGroup.workflowConfiguration.length > 0
  ) {
    analysisGroup.workflowConfiguration = JSON.parse(
      analysisGroup.workflowConfiguration
    );
  } else {
    analysisGroup.workflowConfiguration = null;
  }
  return analysisGroup;
}

export default resource;
